import React, { type FunctionComponent } from 'react'
import { Button } from '../../button/Button'
interface DateRangePickerButtonsProps {
  onCancel: () => void
  onApply: () => void
}
export const DateRangePickerButtons: FunctionComponent<DateRangePickerButtonsProps> = ({
  onCancel,
  onApply,
}) => (
  <div css={{ display: 'flex', justifyContent: 'flex-end' }}>
    <Button
      onClick={onCancel}
      css={{ width: 160 }}
      variant="secondary"
      data-testid="date-range-picker-cancel"
    >
      Cancel
    </Button>

    <Button
      css={{ width: 160, marginRight: 0 }}
      variant="primary"
      onClick={onApply}
      data-testid="date-range-picker-apply"
    >
      Apply
    </Button>
  </div>
)
